module.exports = __webpack_public_path__ + "static/media/groupSettingIcon.e3fe1302.svg";